/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import { Layout } from 'components';

export default function Error403Page() {
    return (
        <>
            <Layout title={''}>
                403 Access Forbidden
            </Layout>
        </>
    );
}